import Header from "@/components/Header";

// Each section: heading, paragraphs (p), optional bullet list (list) inserted after p[listAfter].
const Section = ({ s, idx }) => (
  <section data-testid={`legal-section-${idx + 1}`}>
    <h2 className="text-lg font-bold tracking-tight mb-3">{s.heading}</h2>
    <div className="space-y-3 text-sm sm:text-base text-[#3F3F46] leading-relaxed">
      {s.blocks && s.blocks.map((b, i) =>
        b.h ? <h3 key={i} className="font-bold text-[#0A0A0B] pt-2">{b.h}</h3>
          : b.list ? <ul key={i} className={b.plain ? "space-y-1" : "list-disc pl-5 space-y-1.5"}>{b.list.map((li) => <li key={li}>{li}</li>)}</ul>
          : <p key={i}>{b.p}</p>
      )}
      {(s.p || []).map((para, i) => (
        <div key={i} className="space-y-3">
          <p>{para}</p>
          {s.list && s.listAfter === i && (
            <ul className={s.plainList ? "space-y-1" : "list-disc pl-5 space-y-1.5"}>
              {s.list.map((li) => <li key={li}>{li}</li>)}
            </ul>
          )}
        </div>
      ))}
    </div>
  </section>
);

export const LegalPage = ({ testId, title, updated, sections, closing, notice }) => (
  <div className="min-h-screen bg-white" data-testid={testId}>
    <Header />
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16 md:py-20">
      <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">Get Set Design · Legal</div>
      <h1 className="text-4xl sm:text-5xl tracking-tighter font-black mb-3" data-testid="legal-title">{title}</h1>
      <p className="text-sm text-[#52525B] mb-8" data-testid="legal-updated">Last updated: {updated}</p>
      {notice && (
        <div className="border-l-2 border-[#ED5A24] bg-[#ED5A24]/5 px-4 py-3 mb-10 text-sm" data-testid="legal-notice">{notice}</div>
      )}
      <div className="space-y-10" data-testid="legal-content">
        {sections.map((s, i) => <Section key={s.heading} s={s} idx={i} />)}
      </div>
      {closing && <p className="mt-12 pt-6 border-t border-black/10 text-sm text-[#0A0A0B] font-medium">{closing}</p>}
    </div>
  </div>
);
